import React, { useState, useEffect } from "react";
import man1 from "../../assets/images/me.jpeg";
import man2 from "../../assets/images/chafic.png";
import man3 from "../../assets/images/Elias.jpg";
import "./Team2.css";

const teamMembers = [
  {
    id: "richard",
    name: "Richard Antonios",
    role: "Lead Software Engineer",
    image: man1,
    slideDirection: "slide-left",
    bio: "Richard specializes in full-stack cloud applications, system design, and leading high-throughput development pipelines.",
    skills: ["React", "Node.js", "System Architecture", "Cloud Deployment"],
  },
  {
    id: "chafic",
    name: "Chafic Chamchoum",
    role: "Product Manager & Designer",
    image: man2,
    slideDirection: "slide-bottom",
    bio: "Chafic focuses on user experience design, product strategy, and streamlining cross-functional workflows.",
    skills: ["UI/UX Design", "Product Strategy", "Agile Leadership"],
  },
  {
    id: "elias",
    name: "Elias Chamchoum",
    role: "Solutions Architect",
    image: man3,
    slideDirection: "slide-right",
    bio: "Elias brings deep expertise in infrastructure scalability, automated testing, and enterprise client integrations.",
    skills: ["DevOps", "Database Optimization", "Security & Compliance"],
  },
];

const Team2 = () => {
  const [activePerson, setActivePerson] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          }
        });
      },
      { threshold: 0.15 }
    );

    const elements = document.querySelectorAll(".team2 .animate-side");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setActivePerson(null);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  useEffect(() => {
    if (activePerson) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [activePerson]);

  return (
    <div className="team2">
      <h2 className="animate-side slide-top">Our Team</h2>

      <div className="b1">
        {teamMembers.map((member) => (
          <div
            key={member.id}
            className={`b2 animate-side ${member.slideDirection}`}
            onClick={() => setActivePerson(member)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && setActivePerson(member)}
          >
            <div className="b3">
              <div className="image-wrapper">
                <img
                  className="round-image"
                  src={member.image}
                  alt={member.name}
                />
                <span className="hover-badge">Click for Info</span>
              </div>
              <p>{member.name}</p>
            </div>
          </div>
        ))}
      </div>

      {activePerson && (
        <div
          className="team-modal-overlay"
          onClick={() => setActivePerson(null)}
          aria-modal="true"
          role="dialog"
        >
          <div
            className="team-modal-content"
            onClick={(e) => e.stopPropagation()} 
          >
            <button
              className="team-modal-close"
              onClick={() => setActivePerson(null)}
              aria-label="Close modal"
            >
              &times;
            </button>

            <div className="team-modal-header">
              <img
                src={activePerson.image}
                alt={activePerson.name}
                className="modal-round-image"
              />
              <h3>{activePerson.name}</h3>
              <span className="team-modal-role">{activePerson.role}</span>
            </div>

            <div className="team-modal-body">
              <p className="modal-bio">{activePerson.bio}</p>

              {activePerson.skills && (
                <div className="modal-skills">
                  <h4>Key Expertise</h4>
                  <ul>
                    {activePerson.skills.map((skill, index) => (
                      <li key={index}>{skill}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Team2;